import angular from 'angular'
import './sync_data.service'

angular
  .module('admin.sync_data', ['admin.sync_data.service'])
  .controller('SyncDataAdminCtrl', SyncDataAdminCtrl)

/** @ngInject */
function SyncDataAdminCtrl(SyncDataService) {
  var vm = this

  vm.items = [
    {
      name: 'Search Result',
      isLoading: false,
    },
  ]

  vm.syncNow = function (item) {
    if (item.isLoading) return
    item.isLoading = true
    SyncDataService.syncNow()
      .then(function () {
        toastr.success('Search result data synced successfully')
        item.isLoading = false
      })
      .catch(function () {
        toastr.error('Failed to sync search result data')
        item.isLoading = false
      })
  }
}
